import styles from './styles.module.css'
import { useEffect, useMemo, useState } from 'react'
import NavDrawer from '../nav-drawer/NavDrawer'
import linksData from '../../../global/tsx/links'
import Schedule from '../../../schedule/components/main/ScheduleMain'
import NavLinkPropsWithElement from '../../../global/types/NavLinkPropsWithElement'
import { RequireAuth } from '../../../global/components/auth/RequireAuth'
import { Routes, Route, useLocation } from 'react-router-dom'
import WorkOrdersMain from '../../../work-orders/components/main/WorkOrdersMain'
import ModalContent from '../../../work-orders/components/work-order-detail/components/main/ModalContent'
import { Login } from '../../../login/Login'
import CreditCardUpdateMain from '../../../customer-update-cc-page/components/CreditCardUpdateMain'
import TipsPage from '../../../tips-page/components/TipsPage'
import ReportsMain from '../../../reports/components/main/ReportsMain'
import CustomerSchedulerMain from '../../../customer-scheduler/components/CustomerSchedulerMain'
import JmulletTools from '../../../jmullet-tools/components/JmulletTools'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { fetchData } from '../../../global/utils/fetch'
import { getUserPermissions } from './api'
import { IUser } from '../../../../../app/entities/User'
import QueuesMain from '../../../queues/components/main/QueuesMain'
import VansMain from '../../../vans/main/VansMain'
import { MODES } from '../../../global/constants/scheduler'
import OrderTracker from '../../../order-tracker/components/main/OrderTracker'
import BiReportUploadsMain from '../../../bi-report-uploads/components/main/BiReportUploadsMain'
import TrSalesIframeMain from '../../../tr-sales-appointment-booking/main/TrSalesIframe'

function BaseContainer() {
  const { user } = useAuthenticator((context) => [context.user])
  const [userRole, setUserRole] = useState(localStorage.getItem('Role'))
  const adminLinksData: Array<NavLinkPropsWithElement> = linksData
  const nonAdminLinksData: Array<NavLinkPropsWithElement> = linksData.filter(
    (elem) =>
      elem.title !== 'Locations' &&
      elem.title !== 'User Management' &&
      elem.title !== 'Small Part Inventory',
  )

  const links: Array<NavLinkPropsWithElement> = useMemo(
    () => (userRole === 'Admin' ? adminLinksData : nonAdminLinksData),
    [userRole],
  )

  const { pathname } = useLocation()
  const routesNotDisplayingNavDrawer = [
    /^\/customer-tip-screen\/.+$/,
    /^\/customer-update-cc\/.+$/,
    /^\/login(\/.*)?$/i,
    /^\/status\/.+$/,
    /^\/schedule-appointment\/.+$/,
    /^\/tr-sales$/,
  ]
  const shouldDisplayNavDrawer = !routesNotDisplayingNavDrawer.some((route) =>
    route.test(pathname),
  )

  useEffect(() => {
    //fetch user role & save to local storage
    const fetchUserData = async () => {
      const email = user.username?.split('_')[1] ?? ''
      const userInfo: IUser = await fetchData<IUser>(getUserPermissions(email))
      localStorage.setItem('Role', userInfo.role)
      setUserRole(userInfo.role)
    }
    if (user) {
      fetchUserData()
    }
  }, [user])

  return (
    <div className={styles.baseContainerWrapper}>
      {shouldDisplayNavDrawer && <NavDrawer links={links}></NavDrawer>}
      <Routes>
        <Route
          path={'/jmullet-tools'}
          element={
            <RequireAuth>
              <JmulletTools />
            </RequireAuth>
          }
        />
        <Route
          path={'/tr-sales'}
          element={
            // TODO jlippincott: lock to public until we decide to use it
            <RequireAuth>
              <TrSalesIframeMain />
            </RequireAuth>
          }
        />

        <Route
          path='/vans'
          element={
            <RequireAuth>
              <VansMain />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={
              <RequireAuth>
                <VansMain />
              </RequireAuth>
            }
          />
        </Route>
        <Route
          path={'/schedule-appointment/:id'}
          element={<CustomerSchedulerMain mode={MODES.CUSTOMER} />}
        />
        <Route
          path={'/reschedule-appointment/:id'}
          element={<CustomerSchedulerMain mode={MODES.CUSTOMER_RESCHEDULE} />}
        />
        <Route
          path='/'
          element={
            <RequireAuth>
              <Schedule />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={<ModalContent />}
          />
        </Route>
        <Route
          path='/work-orders'
          element={
            <RequireAuth>
              <WorkOrdersMain />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={<ModalContent />}
          />
        </Route>
        <Route
          path='/queues/reschedule'
          element={
            <RequireAuth>
              <QueuesMain queueType={'reschedule'} />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={<ModalContent />}
          />
        </Route>
        <Route
          path='/queues/tire-rack-data'
          element={
            <RequireAuth>
              <QueuesMain queueType={'tire-rack-data'} />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={<ModalContent />}
          />
        </Route>
        {links.map((link) => (
          <Route
            path={String(link.to)}
            element={link.element}
            key={link.title}
          />
        ))}
        <Route
          path='/reports'
          element={
            <RequireAuth>
              <ReportsMain />
            </RequireAuth>
          }
        >
          <Route
            path=':id'
            element={<ModalContent />}
          />
        </Route>
        <Route
          path='/bi-report-uploads'
          element={
            <RequireAuth>
              <BiReportUploadsMain />
            </RequireAuth>
          }
        ></Route>
        <Route
          path={'/login/*'}
          element={<Login />}
        />
        <Route
          path={'/customer-tip-screen/:id'}
          element={<TipsPage />}
        />
        <Route
          path={'/customer-update-cc/:id'}
          element={<CreditCardUpdateMain />}
        />
        <Route
          path={'/status/:id'}
          element={<OrderTracker />}
        />
      </Routes>
    </div>
  )
}

export default BaseContainer
